import { EErrorCode } from 'config/errors-codes';

export interface IApiErrorOptions {
  statusCode: number;
}

export class ApiError extends Error {
  code: EErrorCode;
  statusCode?: number;

  constructor(code: EErrorCode, message: string, options?: IApiErrorOptions) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.statusCode = options?.statusCode;

    if (typeof window !== 'undefined') {
      // report error to the runtime
      window?.E3D?.reportError(this);
    }
  }
}

export type TExternalApiType = 'vsrs' | 'okapi' | 'vtp' | 'oscar' | 'casa' | 'gmc' | 'naap' | 'dga';

/** The exact property names that contain the error information vary depending on the api. This type contains all possibilities */
export type TExternalApiErrorResponse = {
  status_text?: string;
  error_code?: string;
  error_message?: string;
  error?: string;
  error_description?: string;
  message?: string;
};

export interface IExternalApiErrorOptions extends IApiErrorOptions {
  apiType: TExternalApiType;
  errorData: TExternalApiErrorResponse;
}
export class ExternalApiError extends ApiError {
  statusCode: number;
  apiType: TExternalApiType;
  apiResponse: TExternalApiErrorResponse;

  constructor(code: EErrorCode, options: IExternalApiErrorOptions) {
    const { statusCode, apiType, errorData } = options;
    const message = `${apiType} - ${statusCode} - ${JSON.stringify(errorData)}`;
    super(code, message, { statusCode });
    this.name = 'ExternalApiError';
    this.statusCode = statusCode;
    this.apiType = apiType;
    this.apiResponse = errorData;
  }
}

export class ItemNotFoundError extends Error {}

export class ValidationError extends Error {}
